import { styled } from '@mui/material'
import { ActionButton } from '@/components/primitives/buttons/ActionButton'

export const SubLink = styled(ActionButton, { name: 'SubLink' })({
  padding: '0 !important',
  margin: 0,
})
